import { RootState } from "@/store/store";
import { billingExplorerCsvPossibleColumnsDataSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/csv/possible-columns/billingExplorerCsvPossibleColumnsDataSelector";
import { BillingExplorerCSVColumnItem } from "@/store/resource-explorer/selectors/current-resource-explorer/csv/possible-columns/utils/types";
import { billingExplorerFilterTreeProvidersSelector } from "@/store/resource-explorer/selectors/filter-tree/billingExplorerFilterTreeProvidersSelector";

export const billingExplorerCsvPossibleColumnsFormatedDataSelector = (
  state: RootState,
): BillingExplorerCSVColumnItem[] | undefined => {
  const data = billingExplorerCsvPossibleColumnsDataSelector(state);
  const filterTreeProviders =
    billingExplorerFilterTreeProvidersSelector(state) ?? [];
  if (!data) {
    return;
  }
  const groupedByKey = data?.reduce(
    (result, item) => {
      const prevProvider = result[item.key]?.providers ?? [];

      const newProviders =
        !filterTreeProviders?.length ||
        filterTreeProviders.includes("dimensions") ||
        filterTreeProviders.includes(item.provider)
          ? [item.provider]
          : [];
      result[item.key] = {
        keyValue: item.key,
        label: item.label,
        disabled: item.is_always_included,
        providers: [...prevProvider, ...newProviders],
      };
      return result;
    },
    {} as Record<string, BillingExplorerCSVColumnItem>,
  );

  return Object.values(groupedByKey ?? []) as BillingExplorerCSVColumnItem[];
};
